import { PLATFORM_POLICY_MRN } from "~/lib/mrn";
import { PolicyOverviewTab } from "~/pages/shared/policy/tabs/PolicyOverviewTab";

export function PlatformPolicyOverviewTab() {
  return (
    <PolicyOverviewTab
      entityMrn={PLATFORM_POLICY_MRN}
      defaultScopeType="Organizations"
    />
  );
}
